export const enum AuthenticationType {
	BankId = "BankIdV6",
	MitId = "MitId",
	SmartId = "SmartId",
}

export type AuthenticationTypeV2 = "UsernamePassword";

export interface AuthTransactionState {
	shouldRememberUser?: boolean;
	verificationStatus?: VerificationStatus;
	authenticationToken?: string;
	lastActivePersonalNumber?: string;
	verificationCode?: string;
	qrCode?: string[];
	transactionId?: string;
}

export interface VerificationRequest {
	token?: string;
	personalNumber?: string;
	transactionId?: string;
}

export interface VerificationRequestV2 {
	authenticationType: AuthenticationTypeV2;
	username: string;
	password: string;
	iovationBlackBox: string;
	fraudToken?: string;
}

export interface VerificationCancelRequest {
	authenticationType?: AuthenticationType;
}

export interface AuthTransactionRequest {
	personalNumber?: string;
	shouldRememberUser?: boolean;
	authenticationType?: AuthenticationType;
	startBankIdTimings?: boolean;
}

export interface AuthTransactionResponse {
	token: string;
	personalNumber: string;
	transactionId: string;
	expirationDateTime: string;
	autostartToken: string;
	qrCode?: string[];
}

export interface AuthTransactionResponseV2 {
	transactionId: string;
	jurisdiction: string;
	authenticationToken: string;
	customerCountry: string;
	customerId: string;
}

export interface InitializeSuccessPayload {
	token?: string;
	personalNumber?: string;
	transactionId: string;
	previousTransactionId?: string;
	autostartToken: string;
	verificationCode?: string;
	qrCode?: string[];
	authenticationType?: AuthenticationType;
	startBankIdTimings?: boolean;
}

export interface VerificationStatusRequest {
	token?: string;
	personalNumber?: string;
	transactionId?: string;
	authenticationType?: AuthenticationType;
}

export interface VerificationStatusData extends VerificationStatusRequest {
	previousTransactionId?: string;
	lastStatus?: boolean;
}

export interface CancelRequest {
	token?: string;
	transactionId: string;
	authenticationType?: AuthenticationType;
}

export interface VerificationStatusResponse {
	status: VerificationStatus;
	hintCode: HintCode;
	personalNumber?: string;
	authenticationToken?: string;
	verificationCode?: string;
	transactionTimeout?: boolean;
}

export enum VerificationStatus {
	Completed = "Completed",
	Pending = "Pending",
	Failed = "Failed",
}

export enum HintCode {
	Cancelled = "Cancelled",
	UserCancel = "UserCancel",
	ExpiredTransaction = "ExpiredTransaction",
	CertificateError = "CertificateError",
	StartFailed = "StartFailed",
	AlreadyInProgress = "AlreadyInProgress",
	Unknown = "Unknown",
	ProviderError = "ProviderError",
	Timeout = "Timeout",
	/**
	 * DGA specific
	 */
	CPRNumberNotFound = "CPRNumberNotFound",
	CPRNumberAlreadyRegistered = "CPRNumberAlreadyRegistered",
}
